import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdDelete } from "react-icons/md";
import moment from "moment";
import { ScrollableContent } from "../Styles/InputStyles";
import { ProfileSection, UserInfo } from "../Styles/PageStyles";

const getValueOrDashedIcon = (value) => {
  if (value === null || value === undefined || value === "Invalid date" || value === "") {
    return <span >-</span>;
  }
  return value;
};


const getValidDateOrDashedIcon = (date) => {

  if (!date) {
    return <span >-</span>;
  }

  const formattedDate = moment(date);

  if (!formattedDate.isValid()) {
    return <span className="text-gray-400">—</span>;
  }

  return formattedDate.format("DD-MMM-YY");
};

const ViewDetails = ({
  setViewDetail,
  selectedData,
  setEditBasicDetail,
  setIsAssignmentDetails,
  setIsDeleteAsset
}) => {
  const onClose = () => {
    setViewDetail(false);
  };
  const onEditBasicDetails = () => {
    setViewDetail(false);
    setEditBasicDetail(true)
  };
  const onAssignPropertyDetails = () => {
    setViewDetail(false);
    setIsAssignmentDetails(true)
  };
  const assetTypeMapping = {
    "Furniture & Fixtures": 1,
    "Electrical & Appliances": 2,
    "Plumbing & Sanitary": 3,
    "Security & Access Control": 4,
    "HVAC (Heating, Ventilation & Air Conditioning)": 5,
    "Outdoor & Common Area Assets": 6,
    "IT & Networking Equipment": 7,
    "Kitchen Equipment & Accessories": 8,
    "Miscellaneous Assets": 9,
  };

  const getName = (selectedData) => {
    const assetTypeName = Object.keys(assetTypeMapping).find(
      (key) => assetTypeMapping[key] === selectedData.type
    );
    return <p>{assetTypeName || "Unknown Type"}</p>;
  };

  const getStatusBadge = (status) => {
    const statusStyles = {
      1: "bg-green-100 text-green-700 text-xs border-green-300 border w-18 h-7 flex items-center justify-center rounded-full",
      2: "bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-18 h-7 flex items-center justify-center rounded-full",
      3: "bg-rose-100 text-rose-700 text-xs border-rose-300 border w-18 h-7 flex items-center justify-center rounded-full",
      4: "bg-gray-100 text-gray-800 text-xs border-gray-300 border w-18 h-7 flex items-center justify-center rounded-full",
    };

    const statusText = {
      1: "Active",
      2: "In Maintenance",
      3: "Disposed",
      4: "In Use",
    };

    return (
      <span
        className={`px-4 py-2 rounded-full text-xs ${statusStyles[status] || "bg-gray-100 text-gray-600"}`}
      >
        {statusText[status] || "Not Assigned"}
      </span>
    );
  };

  const handleDeleteExpense = () => {
    setIsDeleteAsset(true);
    // if (property?.id) {
    //   setPropId(property.id);
    // }
  };

  return (
    <Container>
      <div className="flex items-center justify-between bg-[#26A69A] py-4 px-4">
        <Title className="text-white">{"Asset Details"}</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>
      <ProfileSection className="flex justify-between">

        <UserInfo>
          <span className="font-medium">{getName(selectedData)}</span>
          <span className="text-sm text-gray-600">
            {getValueOrDashedIcon(selectedData?.name)}
          </span>
        </UserInfo>
        <div className="flex gap-2">
          <span>{getStatusBadge(selectedData?.status)}</span>
          <MdDelete
            size={20}
            className="text-rose-500 cursor-pointer mt-1"
            title="Delete Expense"
            onClick={handleDeleteExpense}
          />
        </div>
      </ProfileSection>

      <Content>
        <ScrollableContent>
          <Wrapper>
            <BtnWrapper>
              <SectionTitle>Basic Details</SectionTitle>
              <EditButton title="Edit Basic Detail" onClick={onEditBasicDetails}
              >

                Edit</EditButton>
            </BtnWrapper>
            <Section className="mb-3">
              <Row className="pb-4">
                <FlexCol>
                  <Label>Total Units</Label>
                  <Value>{getValueOrDashedIcon(selectedData?.total)}</Value>
                </FlexCol>
                <FlexCol>
                  <div className="flex gap-4">
                    <Label>Remaining Units</Label>
                    {selectedData?.free > 0 &&
                      <EditButton title="Assign Property" onClick={onAssignPropertyDetails}
                      >Assign </EditButton>}
                  </div>
                  <Value>{getValueOrDashedIcon(selectedData?.free)}</Value>
                </FlexCol>
              </Row>
              <div className="">
                <FlexCol>
                  <Label>Description</Label>
                  <Value>{getValueOrDashedIcon(selectedData?.description)}</Value>
                </FlexCol>
              </div>

            </Section>

            <BtnWrapper>
              <SectionTitle>Purchase/Rent Details</SectionTitle>
            </BtnWrapper>
            <Section className="mb-3">
              <Row className="pb-4">
                <FlexCol>
                  <Label>Purchase/Rent Date</Label>
                  <Value>{getValidDateOrDashedIcon(selectedData?.purchaseDate)}</Value>
                </FlexCol>

                <FlexCol>
                  <Label>Purchase/Rent Price</Label>
                  <Value>{getValueOrDashedIcon('₹' + selectedData?.cost)}</Value>
                </FlexCol>
              </Row>
              <Row className="pb-4">
                <FlexCol>
                  <Label>Depreciation(%)</Label>
                  <Value>{getValueOrDashedIcon(selectedData?.depreciationRate)}</Value>
                </FlexCol>

                <FlexCol>
                  <Label>Vendor Name</Label>
                  <Value>{getValueOrDashedIcon(selectedData?.vendorName)}</Value>
                </FlexCol>
              </Row>
              <Row >
                <FlexCol>
                  <Label>Warranty Expire</Label>
                  <Value>{getValidDateOrDashedIcon(selectedData?.warrentyExpire)}</Value>
                </FlexCol>


              </Row>

            </Section>
            {selectedData?.assetDocs && (
              <>
                <BtnWrapper>
                  <SectionTitle>Supported Documents</SectionTitle>
                </BtnWrapper>
                <Section>
                  <Row >

                    <FlexCol>
                      <Label>Invoice</Label>
                      {selectedData.assetDocs?.find((doc) => doc.type === 8) ? (
                        <a
                          href={selectedData.assetDocs.find((doc) => doc.type === 8)?.value}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline text-base"
                        >
                          Click to View
                        </a>
                      ) : (
                        "-"
                      )}
                    </FlexCol>


                    <FlexCol>
                      <Label>Warranty</Label>
                      {selectedData.assetDocs?.find((doc) => doc.type === 9) ? (
                        <a
                          href={selectedData.assetDocs.find((doc) => doc.type === 9)?.value}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline text-base"
                        >
                          Click to View
                        </a>
                      ) : (
                        "-"
                      )}
                    </FlexCol>
                  </Row>
                </Section>
              </>
            )}


          </Wrapper>
        </ScrollableContent>
      </Content>
    </Container>
  );
};

const Wrapper = tw.div`grid gap-1.5 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-600`;
const Section = tw.div` border border-gray-200 p-3 rounded-lg`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 `;
const Label = tw.label`text-sm text-gray-400`;
const Value = tw.span`text-gray-600 text-base`;
const BtnWrapper = tw.div`w-full flex items-center justify-between `;
const FlexCol = tw.div`flex flex-col gap-0.5`
const Content = tw.div`p-4 flex flex-col gap-4`;
const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`
export default ViewDetails;
